// Session cookies on `.${domainName}` must not reach user-content iframes on
// `${edgeDomain}`; keeping their registrable domains disjoint guarantees it.
// "Registrable domain" is the last two labels — fine for our `.com`/`.dev`/`.run`
// TLDs. Compound TLDs (`.co.uk`) would need a Public Suffix List lookup.

export function registrableDomain(hostname: string): string {
  const labels = hostname.replace(/^\./, "").split(".");
  if (labels.length < 2) {
    throw new Error(`Not a registrable domain: ${hostname}`);
  }
  return labels.slice(-2).join(".");
}

export function haveDisjointRegistrableDomains(a: string, b: string): boolean {
  return registrableDomain(a) !== registrableDomain(b);
}

export function assertDisjointRegistrableDomains(a: string, b: string): void {
  if (!haveDisjointRegistrableDomains(a, b)) {
    throw new Error(
      `Expected disjoint registrable domains, got "${a}" and "${b}". ` +
        "Session cookies scoped to one would be visible to content served from the other."
    );
  }
}
